import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { paths } from '.';
import { getAndSaveUser } from 'services/auth';

import PageFormServicos from 'pages/Requerimentos/RequerimentoServicos';
import PageFormDuvidas from 'pages/Requerimentos/RequerimentoDuvidas';
import PagePesquisarProtocolo from 'pages/Protocolo';
import PageDetalharRequerimento from 'pages/Requerimentos/Detalhar';
import PageResumoRequerimento from 'pages/Requerimentos/Resumo/index';
import PageComprovanteRequerimento from 'pages/Requerimentos/Comprovante/index';
import HomePublic from 'pages/HomePublic';
import HeaderTema from 'components/Menu/Tema/index';

export default function Public() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.sefaz.userProfile);

  React.useEffect(() => {
    if (!user) {
      dispatch(getAndSaveUser());
    }
  }, [dispatch, user]);

  return (
    <>
      <HeaderTema />
      <Switch style={{ marginBottom: '200px' }}>
        <Route path={paths.publicRoot} exact component={HomePublic} />
        <Route path={paths.servicos} exact component={PageFormServicos} />
        <Route path={paths.duvidas} exact component={PageFormDuvidas} />
        <Route path={paths.pesquisarProtocolo} exact component={PagePesquisarProtocolo} />
        <Route path={paths.detalharRequerimentoContribuinte} exact component={PageDetalharRequerimento} />
        <Route path={paths.resumoRequerimento} exact component={PageResumoRequerimento} />
        <Route path={paths.comprovanteRequerimento} exact component={PageComprovanteRequerimento} />
      </Switch>
    </>
  );
}
